import { useId } from 'react';
import { Badge, UncontrolledTooltip } from 'reactstrap';

interface StatusSignature {
    studentSigned: boolean;
    institutionSigned: boolean;
    grantorSigned: boolean;
}

interface TceSignatureStatusBadgeProps {
    status: StatusSignature;
}

export const TceSignatureStatusBadge = ({
    status,
}: TceSignatureStatusBadgeProps) => {
    const uniqueId = useId().replace(/:/g, '-');
    const allSigned =
        status.studentSigned && status.institutionSigned && status.grantorSigned;

    if (allSigned) {
        return (
            <Badge color='success' className='d-inline-flex align-items-center gap-1'>
                <i className='ri-checkbox-circle-line'></i>
                Assinado por todos
            </Badge>
        );
    }

    return (
        <div>
            <div
                className='d-flex flex-wrap gap-1'
                id={`signature-status-${uniqueId}`}
                style={{ cursor: 'help' }}
            >
                {status.studentSigned && (
                    <Badge
                        color='success'
                        className='d-inline-flex align-items-center gap-1'
                    >
                        <i className='ri-user-3-line'></i>
                        Estudante
                    </Badge>
                )}

                {status.institutionSigned && (
                    <Badge
                        color='success'
                        className='d-inline-flex align-items-center gap-1'
                    >
                        <i className='ri-building-2-line'></i>
                        Instituição
                    </Badge>
                )}

                {status.grantorSigned && (
                    <Badge
                        color='success'
                        className='d-inline-flex align-items-center gap-1'
                    >
                        <i className='ri-shield-user-line'></i>
                        Concedente
                    </Badge>
                )}
            </div>

            <UncontrolledTooltip
                placement='top'
                target={`signature-status-${uniqueId}`}
            >
                <div className='text-start' style={{ maxWidth: '300px' }}>
                    <div className='d-flex flex-column gap-2'>
                        {status.studentSigned ? (
                            <div className='d-flex align-items-center gap-2'>
                                <Badge color='success' className='d-inline-flex align-items-center'>
                                    <i className='ri-user-3-line' style={{ fontSize: '12px' }}></i>
                                </Badge>
                                <small>Tce assinado pelo estudante</small>
                            </div>
                        ) : (
                            <div className='d-flex align-items-center gap-2'>
                                <Badge color='secondary' className='d-inline-flex align-items-center'>
                                    <i className='ri-user-3-line' style={{ fontSize: '12px' }}></i>
                                </Badge>
                                <small>Aguardando assinatura do estudante</small>
                            </div>
                        )}

                        {status.institutionSigned ? (
                            <div className='d-flex align-items-center gap-2'>
                                <Badge color='success' className='d-inline-flex align-items-center'>
                                    <i className='ri-building-2-line' style={{ fontSize: '12px' }}></i>
                                </Badge>
                                <small>Tce assinado pela instituição</small>
                            </div>
                        ) : (
                            <div className='d-flex align-items-center gap-2'>
                                <Badge color='secondary' className='d-inline-flex align-items-center'>
                                    <i className='ri-building-2-line' style={{ fontSize: '12px' }}></i>
                                </Badge>
                                <small>Aguardando assinatura da instituição</small>
                            </div>
                        )}

                        {status.grantorSigned ? (
                            <div className='d-flex align-items-center gap-2'>
                                <Badge color='success' className='d-inline-flex align-items-center'>
                                    <i className='ri-shield-user-line' style={{ fontSize: '12px' }}></i>
                                </Badge>
                                <small>Tce assinado pelo concedente</small>
                            </div>
                        ) : (
                            <div className='d-flex align-items-center gap-2'>
                                <Badge color='secondary' className='d-inline-flex align-items-center'>
                                    <i className='ri-shield-user-line' style={{ fontSize: '12px' }}></i>
                                </Badge>
                                <small>Aguardando assinatura do concedente</small>
                            </div>
                        )}
                    </div>
                </div>
            </UncontrolledTooltip>
        </div>
    );
};
